<script>
import { mapActions } from 'vuex';

export default {
  name: 'SkiRentalWrapper',
  methods: {
    ...mapActions({
      resetState: 'skirental/resetState',
    }),
  },
  destroyed() {
    this.resetState();
  },
};
</script>

<template>
  <v-content>
    <router-view></router-view>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/ski/rental/SkiRentalWrapper.vue